export const krAddress = {
 addressLine1: '방화동 양천로 81 쥬피터빌딩,3층',
 city: '서울',
 state: '강서구',
}

export const jpAddress = {
  addressLine1: 'ショッピングカート合同会社',
  state: '仙台市 若林区木ノ下',
  city: '宮城県',
  chome: '3-1-2'
}


/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/constants.js
 **/